<template>
  <div class="_title">
    <span class="_name"> {{ name }} </span>
    <span class="_english"> {{ english }} </span>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      default: "",
    },
    english: {
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
._title {
  width: 100%;
  height: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ._name {
    font-size: 0.3rem;
    color: #083875;
    font-weight: bold;
  }
  ._english {
    margin-top: 0.15rem;
    font-size: 0.2rem;
    color: #adb9c8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Title.vue